<template>
  <div class="blog-page__header">
    <div class="container">
      <h1 class="blog-page__title">Journal</h1>
      <p class="blog-page__description">
        Planning your dream getaway? Be inspired by insider tips, road trips and
        must-read travel guides to the places that we, and some of our favourite
        muses and creatives, love most.
      </p>
    </div>
  </div>
  <div class="container">
    <BlogTypes
      :types="journalTypes"
      :selected-type="selectedType"
      @change="(val) => (selectedType = val)"
    />
  </div>
  <div class="blog-grid container container--flush">
    <JournalTile
      v-for="entry in journalEntries"
      :key="entry.id"
      :entry="entry"
    />
  </div>
</template>

<script>
import BlogTypes from "@/components/journal/BlogTypes.vue";
import JournalTile from "@/components/journal/JournalTile";
import journalQuery from "@/graphql/queries/JournalPage.gql";
import { unwrapNodes } from "@/helpers/graphql";
import { RelayConnection } from "@/helpers/pagination";
import { getParams } from "@/helpers/url.js";

export default {
  name: "BlogPage",
  components: {
    JournalTile,
    BlogTypes,
  },
  data() {
    return {
      journal: {
        articles: new RelayConnection(),
      },
      selectedType: getParams().tag || null,
      journalTypes: [],
    };
  },
  computed: {
    journalEntries() {
      return unwrapNodes(this.journal.articles?.edges);
    },
  },
  watch: {
    selectedType(tag) {
      this.setTagUrl(tag);
    },
  },
  created() {
    this.loadJournalTypes();
  },
  methods: {
    setTagUrl(tag) {
      const url = new URL(window.location);

      if (tag) {
        url.searchParams.set("tag", tag);
      } else {
        url.searchParams.delete("tag");
      }

      window.history.replaceState(null, "", url.toString());
    },
    resolveTagLabel(tag) {
      if (!tag) return null;

      const match = this.journalTypes.find(
        (type) => type.label.toLowerCase() === String(tag).toLowerCase()
      );

      return match ? match.label : tag;
    },
    async loadJournalTypes() {
      const { data } = await this.$apollo.query({
        query: journalQuery,
        variables: { query: null },
      });

      let arrayOfTypes = [];
      unwrapNodes(data?.blog?.articles?.edges).forEach(({ tags }) => {
        arrayOfTypes = [...arrayOfTypes, ...tags];
      });

      const uniqueAndCount = new Map();
      arrayOfTypes.forEach((tag) => {
        uniqueAndCount.set(tag, 1 + (uniqueAndCount.get(tag) || 0));
      });

      this.journalTypes = [...uniqueAndCount]
        .map(([key, value]) => ({
          label: key,
          count: value,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      this.selectedType = this.resolveTagLabel(this.selectedType);
    },
  },
  apollo: {
    journal: {
      query: journalQuery,
      variables() {
        return {
          query: this.selectedType ? "tag:" + this.selectedType : null,
        };
      },
      update: (data) => {
        return data.blog;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-page__header {
  background-color: $color-grey-light;
  padding: 60px 20px;

  @include respond-above(md) {
    padding: 80px 40px;
  }
}

.blog-page__title {
  @include t__editorial-headline-10;

  @include respond-above(md) {
    @include t__editorial-headline-30;
  }
}

.blog-page__description {
  margin-top: 10px;
  font-size: 14px;
  @include t__editorial-sub-headline-20;

  @include respond-above(md) {
    @include t__editorial-sub-headline-20;
    max-width: 60%;
  }
}

.blog-grid {
  display: grid;
  gap: 2px;

  @include respond-above(md) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2px;
  }
}
</style>
